import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { inServerText } from "@/components/network/StatusPill";

// SERVER induk perangkat (OLT/OTB/Splitter), dibaca dari keanggotaan SERVER. onSelect = mode panel Peta.
export function ServerInfo({ kind, id, onSelect }) {
  const [s, setS] = useState(undefined);
  useEffect(() => {
    setS(undefined);
    api.get(`/network/server-of/${kind}/${id}`).then((r) => setS(r.data.server)).catch(() => setS(false));
  }, [kind, id]);
  if (s === undefined || s === false) return null;
  const label = s && <><span className="font-mono-tab">{s.kode}</span> · {s.nama}</>;
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-xs" data-testid={`server-info-${kind}`}>
      <span className="text-[#6B7280]">{s ? s.label : kind === "splitter" ? "SERVER/FDT/ODP" : "SERVER/FDT"}:</span>
      {!s ? <span className="text-[#6B7280]" data-testid="server-info-none">Belum ditempatkan di {kind === "splitter" ? "SERVER/FDT/ODP" : "SERVER/FDT"}</span>
        : onSelect && s.label !== "FDT" ? <button type="button" className="font-semibold text-[#0055FF] hover:underline" onClick={() => onSelect({ kind: s.label === "ODP" ? "odp" : "server", id: s.id })} data-testid="server-info-link">{label}</button>
          : <Link to={s.label === "FDT" ? `/network/fdt?fdt_id=${s.id}` : s.label === "ODP" ? `/network/odp?odp_id=${s.id}` : `/network/server?server_id=${s.id}`} className="font-semibold text-[#0055FF] hover:underline" data-testid="server-info-link">{label}</Link>}
      {s && <span className="text-[#6B7280]" data-testid="server-info-loc">· Lokasi: {inServerText(s)}</span>}
      {s?.archived && <span className="rounded bg-[#E5E7EB] px-1 text-[10px] font-semibold text-[#374151]" data-testid="server-info-archived">ARSIP</span>}
    </div>
  );
}
